module.exports = __webpack_public_path__ + "assets/img/email_2.436fdd80.svg";